import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "planning-tutorial-msg-4",
  "use": "planning-tutorial-msg-4-usage",
  "viewBox": "0 0 57 41",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 57 41\" id=\"planning-tutorial-msg-4\"><path fill=\"#C5C5C5\" d=\"M56.202 2.975q.135-.008.27-.017l.053.837.168.118-4.91 7.037-.82-.573 4.425-6.34C32.425 5.813 14.498 18.13 1.562 41.027l-.87-.493C13.487 17.884 31.178 5.42 53.728 3.18l-5.58-1.93.328-.945zm-.655.832-.16.23q.572-.045 1.148-.08l-.01-.162-.474-.33-.16.46-.34-.118zm.655-.832q-1.246.082-2.474.204l1.82.624.325-.466.178.124.17-.484-.015-.004z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol